import { FunnelIcon, XMarkIcon } from '@heroicons/react/24/outline'

export default function InboxFilters({ filters, onChange, onClear }) {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'active', label: 'Active' },
    { value: 'resolved', label: 'Resolved' },
    { value: 'flagged', label: 'Flagged' },
    { value: 'needs_attention', label: 'Needs Attention' },
  ]

  const hasActiveFilters = filters.status !== 'all' || filters.dateFrom || filters.dateTo || filters.agent || filters.source

  return (
    <div className="flex items-center space-x-2 flex-wrap gap-y-2">
      <select
        value={filters.status}
        onChange={(e) => onChange({ ...filters, status: e.target.value })}
        className="px-3 py-1.5 border border-slate-200 rounded-lg text-xs text-slate-700 focus:outline-none focus:ring-2 focus:ring-brand-500"
      >
        {statusOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      <select
        value={filters.source || 'all'}
        onChange={(e) => onChange({ ...filters, source: e.target.value === 'all' ? null : e.target.value })}
        className="px-3 py-1.5 border border-slate-200 rounded-lg text-xs text-slate-700 focus:outline-none focus:ring-2 focus:ring-brand-500"
      >
        <option value="all">All Channels</option>
        <option value="widget">Widget</option>
        <option value="whatsapp">WhatsApp</option>
      </select>
      <input
        type="date"
        value={filters.dateFrom || ''}
        onChange={(e) => onChange({ ...filters, dateFrom: e.target.value || null })}
        className="px-2 py-1.5 border border-slate-200 rounded-lg text-xs text-slate-700 focus:outline-none focus:ring-2 focus:ring-brand-500"
        placeholder="From"
      />
      <input
        type="date"
        value={filters.dateTo || ''}
        onChange={(e) => onChange({ ...filters, dateTo: e.target.value || null })}
        className="px-2 py-1.5 border border-slate-200 rounded-lg text-xs text-slate-700 focus:outline-none focus:ring-2 focus:ring-brand-500"
        placeholder="To"
      />
      {hasActiveFilters && (
        <button
          onClick={onClear}
          className="flex items-center space-x-1 px-2 py-1.5 text-xs text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-lg transition-colors"
        >
          <XMarkIcon className="h-3 w-3" />
          <span>Clear</span>
        </button>
      )}
    </div>
  )
}
